import { render, staticRenderFns } from "./PJDirectorsProxies.vue?vue&type=template&id=6116c5a5"
import script from "./PJDirectorsProxies.vue?vue&type=script&lang=js"
export * from "./PJDirectorsProxies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports